import { TDealType, TOfferType } from '@cian/api-models/offer-card/v1/get-offer-data';
import { IMakeRequest } from '../../utils/make_request';
import { isResponseContainsKey } from '../../utils/response';
import { filterServerResponse } from '../helpers';
import { IServerError } from '../types';
import { mergeBaseUri } from '@cian/http-api/shared';

export interface ISuccessResponse {
  data: {
    logOnInfo?: ILogonInfo[],
    login?: string;
    isEmailConfirmed?: boolean;
  };
  status: 'ok';
}

export interface IErrorResponse {
  statusCode: number;
}

export interface ILogonInfo {
  logOnUrl: string;
  token: string;
}

export function sendSubscriptionPriceChanges(
  makeRequest: IMakeRequest,
  host: string,
  email: string,
  offerId: number,
  dealType: TDealType,
  offerType: TOfferType,
  subscribeNews: boolean,
): Promise<ISuccessResponse | IServerError> {
  return makeRequest({
    body: JSON.stringify({
      email,
      offerId,
      subscribeNews,
    }),
    headers: [
      ['Content-Type', 'application/json'],
    ],
    method: 'POST',
    uri: mergeBaseUri(host, {
      path: '/cian-api/site/v1/change-price-subscribe/',
    }),
  })
  .then(filterServerResponse)
  .then(response => JSON.parse(response.responseBody))
  .then(response => {
    if (!isResponseContainsKey<ISuccessResponse, IServerError>(response, 'errors')) {
      return response;
    }

    throw response;
  });
}

export function sendUnsubscriptionPriceChanges(
  makeRequest: IMakeRequest,
  host: string,
  offerId: number,
): Promise<ISuccessResponse | IServerError> {
  return makeRequest({
    body: JSON.stringify({
      offerId,
    }),
    headers: [
      ['Content-Type', 'application/json'],
    ],
    method: 'POST',
    uri: mergeBaseUri(host, {
      path: '/cian-api/site/v1/change-price-unsubscribe/',
    }),
  })
  .then(filterServerResponse)
  .then(response => JSON.parse(response.requestBody))
  .then(response => {
    if (!isResponseContainsKey<ISuccessResponse, IServerError>(response, 'errors')) {
      return response;
    }

    throw response;
  });
}
